'use client'

export default function NotFoundFooter({ marginClass }: any) {
  const currentYear = new Date().getFullYear()

  return (
    <footer
      className={`${marginClass} w-full bg-[#0B132B] px-4 py-4 text-white sm:px-6 md:px-8 lg:px-12`}
    >
      <div className="mx-auto max-w-full">
        {/* Desktop Layout */}
        <div className="hidden items-center justify-between gap-4 lg:flex">
          {/* Left - Copyright */}
          <div className="shrink-0">
            <p className="text-sm text-gray-300">© {currentYear} Ababil</p>
          </div>

          {/* Center - Navigation Links */}
          <nav className="flex flex-wrap items-center justify-center gap-3 xl:gap-4">
            <a
              href="#"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Sign Up
            </a>
            <span className="footer-divider">·</span>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="cursor-pointer border-none bg-transparent text-gray-300 transition-colors hover:text-white"
            >
              Log In
            </button>
            <span className="footer-divider">·</span>
            <a
              href="#ceo-message"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              About
            </a>
            {/* <span className="footer-divider">·</span>
            <a
              href="#"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Create Space
            </a> */}
            {/* <span className="footer-divider">·</span> */}
            {/* <a
              href="#"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Share
            </a> */}
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://careers.myababil.com"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Careers
            </a>
            {/* <span className="footer-divider">·</span> */}
            {/* <a
              href="#"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Help
            </a> */}
            <span className="footer-divider">·</span>
            <a
              href="https://legal.myababil.com/privacy-policy"
              target="_blank"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Privacy
            </a>
            <span className="footer-divider">·</span>
            <a
              href="https://legal.myababil.com/terms"
              target="_blank"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Terms
            </a>
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://legal.myababil.com/privacy-policy"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Cookies
            </a>
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://legal.myababil.com/fraud-detection"
              className="text-sm whitespace-nowrap text-gray-300 transition-colors hover:text-white"
            >
              Fraud Detection
            </a>
          </nav>

          {/* Right - Crafted with love */}
          <div className="flex shrink-0 items-center gap-1.5">
            <span className="text-sm text-gray-300">Crafted with</span>
            <span className="text-sm">❤️</span>
            <span className="text-sm text-gray-300">in humanity</span>
          </div>
        </div>

        {/* Tablet Layout (md to lg) */}
        <div className="hidden flex-col gap-4 md:flex lg:hidden">
          <div className="flex items-center justify-between">
            <p className="text-sm text-gray-300">© {currentYear} Ababil</p>
            <div className="flex items-center gap-1.5">
              <span className="text-sm text-gray-300">Crafted with</span>
              <span className="text-sm">❤️</span>
              <span className="text-sm text-gray-300">in humanity</span>
            </div>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-3">
            <a
              href="#"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Sign Up
            </a>
            <span className="footer-divider">·</span>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="cursor-pointer border-none bg-transparent text-gray-300 transition-colors hover:text-white"
            >
              Log In
            </button>
            <span className="footer-divider">·</span>
            <a
              href="#ceo-message"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              About
            </a>
            {/* <span className="footer-divider">·</span>
            <a
              href="#"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Create Space
            </a>
            <span className="footer-divider">·</span>
            <a
              href="#"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Share
            </a> */}
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://careers.myababil.com"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Careers
            </a>
            {/* <span className="footer-divider">·</span>
            <a
              href="#"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Help
            </a> */}
            <span className="footer-divider">·</span>
            <a
              href="https://legal.myababil.com/privacy-policy"
              target="_blank"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Privacy
            </a>
            <span className="footer-divider">·</span>
            <a
              href="https://legal.myababil.com/terms"
              target="_blank"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Terms
            </a>
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://legal.myababil.com/privacy-policy"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Cookies
            </a>
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://legal.myababil.com/fraud-detection"
              className="text-sm text-gray-300 transition-colors hover:text-white"
            >
              Fraud Detection
            </a>
          </nav>
        </div>

        {/* Mobile Layout (below md) */}
        <div className="flex flex-col gap-4 md:hidden">
          <p className="text-center text-xs text-gray-300 sm:text-sm">
            © {currentYear} Ababil
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-2 text-xs sm:text-sm">
            <a
              href="#"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Sign Up
            </a>
            <span className="footer-divider">·</span>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="cursor-pointer border-none bg-transparent text-gray-300 transition-colors hover:text-white"
            >
              Log In
            </button>
            <span className="footer-divider">·</span>
            <a
              href="#ceo-message"
              className="text-gray-300 transition-colors hover:text-white"
            >
              About
            </a>
            {/* <span className="footer-divider">·</span>
            <a
              href="#"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Create Space
            </a> */}
            {/* <span className="footer-divider">·</span>
            <a
              href="#"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Share
            </a> */}
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://careers.myababil.com"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Careers
            </a>
            {/* <span className="footer-divider">·</span>
            <a
              href="#"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Help
            </a> */}
            <span className="footer-divider">·</span>
            <a
              href="https://legal.myababil.com/privacy-policy"
              target="_blank"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Privacy
            </a>
            <span className="footer-divider">·</span>
            <a
              href="https://legal.myababil.com/terms"
              target="_blank"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Terms
            </a>
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://legal.myababil.com/privacy-policy"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Cookies
            </a>
            <span className="footer-divider">·</span>
            <a
              target="_blank"
              href="https://legal.myababil.com/fraud-detection"
              className="text-gray-300 transition-colors hover:text-white"
            >
              Fraud Detection
            </a>
          </nav>
          <div className="flex items-center justify-center gap-1.5 text-xs sm:text-sm">
            <span className="text-gray-300">Crafted with</span>
            <span>❤️</span>
            <span className="text-gray-300">in humanity</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
